export enum ZIndexPriority {
  LOW = 10,
  MEDIUM = 50,
  HIGH = 100
}

export const modalZIndexPriority = { overlay: { zIndex: ZIndexPriority.HIGH } }
